import { Box, ColorOptions, IconNew, IconNewOptions, ModalDialogNew, SpacerNew, Text, TextNew } from '@jfs/ui-new'
import { useEffect, useState } from 'react'
import { ActivityIndicator } from 'react-native'
import { combineUserName, customTheme } from '../../util/util'
import { styles } from './styles'

export interface UserActionPopupInterface {
  visibility: boolean
  type: ModalTypes
  onActionPress: () => void
  hideModal?: () => void
  closeModal: () => void
  isLoading: boolean
  data: any
}

export enum ModalTypes {
  block = 'block',
  delete = 'delete',
  unblock = 'unblock',
}

interface ContentInterface {
  type: ModalTypes
  onActionPress: () => void
  hideModal: () => void
  isLoading: boolean
  data: any
}

interface IconTextInterface {
  id: IconNewOptions
  name: string
}

interface ActionButtonInterface {
  title: string
  bgColor: ColorOptions
  textColor: ColorOptions
  onActionPress?: () => void
  hideModal?: () => void
  isLoading?: boolean
}

export const UserActionPopup = ({
  visibility = false,
  type,
  onActionPress,
  closeModal,
  isLoading,
  data,
}: UserActionPopupInterface) => {
  const [visible, setVisibility] = useState(false)
  const [modalType, setModalType] = useState('block' as ModalTypes)
  const hideModal = () => {
    setVisibility(false)
    closeModal()
  }

  useEffect(() => {
    setVisibility(visibility)
    setModalType(type as ModalTypes)
  }, [type, visibility])

  return (
    <ModalDialogNew
      children={
        <Content
          type={modalType}
          onActionPress={onActionPress}
          hideModal={hideModal}
          isLoading={isLoading}
          data={data}
        />
      }
      show={visible}
      onClose={hideModal}
      onDismiss={hideModal}
      type="centeredWrap"
    />
  )
}

const Content = ({ type, onActionPress, hideModal, isLoading, data }: ContentInterface) => {
  const isDangerType = type === 'delete'
  const isUnBlock = type === 'unblock'
  const userMobile = data?.user?.mobile?.mobileNumber ?? 'N/A'
  const userObj = data?.user?.name
  const email = data?.email
  const userName = combineUserName(userObj)
  return (
    <Box {...styles.mainContainer} testID={`user-management-${userMobile}${email}`}>
      <Box {...styles.subContainer}>
        <TextNew
          title={`Are you sure, you want to ${isDangerType ? 'delete' : isUnBlock ? 'unblock' : 'block'} this user?`}
          {...styles.title}
        />
        <Box
          {...styles.itemContainer}
          borderLeftColor={
            isDangerType
              ? (customTheme.colors.ERROR_RED as ColorOptions)
              : isUnBlock
                ? (customTheme.colors.GREEN_C as ColorOptions)
                : (customTheme.colors.ORANGE_C as ColorOptions)
          }>
          <IconText id="USER" name={userName ?? 'NA'} />
          <IconText id="ACCOUNT" name={data?.email ?? 'NA'} />
          <IconText id="MOBILE" name={userMobile ?? 'NA'} />
        </Box>
      </Box>
      <SpacerNew size={20} />
      <Box {...styles.separator} />
      <Box {...styles.btnContainer}>
        <ActionButton
          title={isDangerType ? 'Don’t Delete' : isUnBlock ? 'Don’t Unblock' : 'Don’t Block'}
          bgColor={customTheme.colors.WHITE as ColorOptions}
          textColor="BLUE"
          hideModal={hideModal}
        />
        <SpacerNew size={16} direction="horizontal" />
        <ActionButton
          title={isDangerType ? 'Delete User' : isUnBlock ? 'Unblock User' : 'Block User'}
          bgColor={
            isDangerType
              ? (customTheme.colors.ERROR_RED as ColorOptions)
              : isUnBlock
                ? (customTheme.colors.GREEN_C as ColorOptions)
                : (customTheme.colors.ORANGE_C as ColorOptions)
          }
          isLoading={isLoading}
          textColor="WHITE"
          onActionPress={onActionPress}
        />
      </Box>
      {isDangerType && (
        <Box {...styles.subContainer} pt={16} maxWidth={400}>
          <Text fontFamily="jioType-medium" color="RED">
            Note: User once deleted cannot be added again with same mobile number.
          </Text>
        </Box>
      )}
    </Box>
  )
}

const IconText = ({ id, name }: IconTextInterface) => {
  return (
    <Box {...styles.textIconCont}>
      <IconNew id={id} size={16} color={'BLACK_21'} />
      <SpacerNew size={8} direction={'horizontal'} />
      <Box {...styles.textContainer}>
        <TextNew title={name} {...styles.iconTitleText} />
      </Box>
    </Box>
  )
}

const ActionButton = ({
  title,
  bgColor,
  textColor,
  onActionPress,
  hideModal,
  isLoading = false,
}: ActionButtonInterface) => {
  return (
    <Box
      {...styles.cancelButton(bgColor)}
      onPress={onActionPress ?? hideModal}
      testID={'action-btn-' + title.replaceAll(' ', '')}>
      {!isLoading && <TextNew fontSize={12} title={title} color={textColor} />}
      {isLoading && <ActivityIndicator size={12} style={styles.activityIndicator} color={textColor} />}
    </Box>
  )
}
